import { AllocationDestination } from '@cash-web/protos/squareup/cash/paychecks/common.pb'

export function getDisplayNameFromAllocationDestination(allocationDestination?: AllocationDestination) {
  if (allocationDestination?.investing) {
    return allocationDestination.investing.ui_specification?.display_name
  }
  if (allocationDestination?.savings) {
    return allocationDestination.savings.ui_specification?.name
  }
  return undefined
}
